import { useMutation } from "@tanstack/react-query";

import { api, queryClient } from "@contexts";
import { RequestType } from "@interfaces";

interface SetRequestDocumentTypePayload {
  documentType: RequestType;
}

interface SetRequestDocumentTypeResponse {
  message: string;
}

interface SetRequestDocumentTypeParams {
  requestId: string;
  documentType: RequestType;
}

export const setRequestDocumentTypeFn = (
  requestId: string,
  payload: SetRequestDocumentTypePayload,
) => {
  return api<SetRequestDocumentTypeResponse>({
    method: "PATCH",
    url: `/requests/${requestId}`,
    data: payload,
  });
};

export const useSetRequestDocumentType = () => {
  return useMutation({
    mutationFn: ({ requestId, documentType }: SetRequestDocumentTypeParams) =>
      setRequestDocumentTypeFn(requestId, { documentType }),
    onSuccess: (_, { requestId }) => {
      queryClient.invalidateQueries({ queryKey: ["request", requestId] });
      queryClient.invalidateQueries({ queryKey: ["requests"] });
    },
    onError: (error) => {
      console.error("Error setting request document type: ", error);
      throw error;
    },
  });
};
